import { FontFamily } from '../components/Font/fontConstants';

/** Placeholder token replaced with locale-specific fallback fonts at runtime. */
export const localeFontFallbackPlaceholder = '[locale specific font fallback]';

/** Map of locale codes to their corresponding font families */
export const localeFallbackFontMap: Record<string, FontFamily> = {
  'bn-BD': FontFamily.NOTO_SANS_BENGALI,
  'bn-IN': FontFamily.NOTO_SANS_BENGALI,
  'zh-Hans': FontFamily.NOTO_SANS_SC,
  'zh-Hant': FontFamily.NOTO_SANS_TC,
  'hi-IN': FontFamily.NOTO_SANS_DEVANAGARI,
  'mr-IN': FontFamily.NOTO_SANS_DEVANAGARI,
  'gu-IN': FontFamily.NOTO_SANS_GUJARATI,
  'ja-JP': FontFamily.NOTO_SANS_JAPANESE,
  'kn-IN': FontFamily.NOTO_SANS_KANNADA,
  'ko-KR': FontFamily.NOTO_SANS_KR,
  'ml-IN': FontFamily.NOTO_SANS_MALAYALAM,
  pa: FontFamily.NOTO_SANS_GURMUKHI,
  'ta-IN': FontFamily.NOTO_SANS_TAMIL,
  'te-IN': FontFamily.NOTO_SANS_TELUGU,
} as const;

/**
 * Font tokens containing placeholders that need locale-specific fallback injection for Snapchat
 * branding.
 */
export const fontTokensWithPlaceholders = {
  '--h1-font-family': `${FontFamily.PROGRAM_OT}, Helvetica Heading, Tahoma Heading, ${localeFontFallbackPlaceholder}, Arial, sans-serif`,
  '--h2-font-family': `${FontFamily.PROGRAM_OT}, Helvetica Heading, Tahoma Heading, ${localeFontFallbackPlaceholder}, Arial, sans-serif`,
} as const;
